
function UserTask({username, task, responses}) {

  const getResponseByAction=(actionId) =>{
    const curr = responses.filter(c=>c.username === username && c.action===actionId)
    return (curr.length)? curr[0] : null
  }
  return (
    <>

    {task.actions.map((action)=>{
      const response = getResponseByAction(action._id)
      return (
        <td key={action._id} className="table__cell ">
         {response? response.grade : '--'}
        </td>
      )
    })}    
    </>
  )
}

export default UserTask